export default "__VITE_ASSET__03162f85__"